import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Requests } from "./Requests";
import { Leads } from "./Leads";

// One inbox for all incoming leads — Assessment submissions + AI bot leads —
// so a new lead never hides under the wrong tab. Tabs show unread counts.
export function LeadsInbox() {
  const [tab, setTab] = useState("requests");
  const [counts, setCounts] = useState({ requests: 0, leads: 0 });

  useEffect(() => {
    const isNew = (s) => !s || String(s).toLowerCase() === "new";
    Promise.all([
      api.get("/client-requests").then((r) => (r.data || []).filter((x) => isNew(x.status) && x.lifecycle !== "archived").length).catch(() => 0),
      api.get("/admin/leads").then((r) => (r.data || []).filter((x) => isNew(x.status)).length).catch(() => 0),
    ]).then(([requests, leads]) => setCounts({ requests, leads }));
  }, []);

  const Badge = ({ n }) => n > 0 ? (
    <span className="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[11px] font-semibold bg-gold text-navy rounded-full">{n}</span>
  ) : null;

  const tabCls = (t) => `px-4 py-2.5 text-sm -mb-px border-b-2 transition-colors flex items-center ${tab === t ? "border-gold text-gold" : "border-transparent text-gray-400 hover:text-white"}`;

  return (
    <div data-testid="leads-inbox">
      <div className="flex gap-1 mb-6 border-b border-white/10">
        <button onClick={() => setTab("requests")} data-testid="inbox-tab-requests" className={tabCls("requests")}>
          Assessment Requests<Badge n={counts.requests} />
        </button>
        <button onClick={() => setTab("leads")} data-testid="inbox-tab-leads" className={tabCls("leads")}>
          AI Leads<Badge n={counts.leads} />
        </button>
      </div>
      {tab === "requests" ? <Requests /> : <Leads />}
    </div>
  );
}
